export function setNewFeedbackInstance(payload) {
  return {
    type: 'FEED_BACK_INSTANCE',
    payload: payload,
  };
}

const initialState = {
  instance: {},
};

export default function feedback(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'FEED_BACK_INSTANCE': {
      return { ...state, ...{ instance: payload } };
    }
    default: {
      return { ...state };
    }
  }
}
